export default {
  breadcrumbsJSON (path, page) {
    let oldBreadcrumbs = document.getElementById('breadcrumbsSchema')
    if (path === '/' || path === '/ru') {
      if (oldBreadcrumbs) {
        oldBreadcrumbs.parentElement.removeChild(oldBreadcrumbs)
      }
      return
    }
    let breadcrumbsJSON
    if (oldBreadcrumbs) {
      breadcrumbsJSON = oldBreadcrumbs
    } else {
      breadcrumbsJSON = document.createElement('script')
      breadcrumbsJSON.setAttribute('id', 'breadcrumbsSchema')
      breadcrumbsJSON.setAttribute('type', 'application/ld+json')
    }
    breadcrumbsJSON.innerHTML = `{"@context": "http://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [{
                                  "@type": "ListItem",
                                  "position": 1,
                                  "item": {
                                    "@id": "${location.origin}",
                                    "name": "➊ ENTER FIFA"
                                  }
                                },{
                                  "@type": "ListItem",
                                  "position": 2,
                                  "item": {
                                    "@id": "${location.origin + path}",
                                    "name": "➋ ${page.toUpperCase()}"
                                  }
                                }]
                              }`

    document.head.appendChild(breadcrumbsJSON)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/index.js